/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { HalJson } from '../models/hal-json';
import { OrderCheckoutStatus } from '../models/order-checkout-status';
import { ordersOrderIdCheckinPost } from '../fn/checkin/orders-order-id-checkin-post';
import { OrdersOrderIdCheckinPost$Params } from '../fn/checkin/orders-order-id-checkin-post';

@Injectable({ providedIn: 'root' })
export class CheckinService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ordersOrderIdCheckinPost()` */
  static readonly OrdersOrderIdCheckinPostPath = '/orders/{orderId}/checkin';

  /**
   * Endpoint to perform checkin and update vehicle details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ordersOrderIdCheckinPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersOrderIdCheckinPost$Response(params: OrdersOrderIdCheckinPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & OrderCheckoutStatus>> {
    return ordersOrderIdCheckinPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Endpoint to perform checkin and update vehicle details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ordersOrderIdCheckinPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  ordersOrderIdCheckinPost(params: OrdersOrderIdCheckinPost$Params, context?: HttpContext): Observable<{
'_links'?: HalJson;
} & OrderCheckoutStatus> {
    return this.ordersOrderIdCheckinPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'_links'?: HalJson;
} & OrderCheckoutStatus>): {
'_links'?: HalJson;
} & OrderCheckoutStatus => r.body)
    );
  }

}
